import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import promotedVideoStrip from './promotedVideoStrip';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest, hourlyBannerUser } from './hourlyBannerUserAndGuest';
import { projectManagementBanner } from './projectManagementBanner';
import { adsPlacement } from './adsPlacements';
import { hourlyToggleFilter } from './hourlyToggleFilter';

const experiments = {
    sortByPrice,
    promotedVideoStrip,
    agenciesInListingsGD,
    hourlyBannerGuest,
    hourlyBannerUser,
    projectManagementBanner,
    adsPlacement,
    hourlyToggleFilter,
};

export const clientExperiments = getAllocationUtils(experiments);
